import type { Transaction } from '../types/transaction'

export const checkIfTransactionIsValid = (
  transaction: Transaction,
): boolean => {
  switch (transaction.category) {
    case 'blank': {
      return transaction.ins.length === 0 && transaction.outs.length === 0
    }
    case 'borrow': {
      return transaction.ins.length === 1 && transaction.outs.length === 0
    }
    case 'deposit': {
      return transaction.ins.length === 0 && transaction.outs.length === 1
    }
    case 'fee': {
      return transaction.ins.length === 0 && transaction.outs.length === 1
    }
    case 'income': {
      return transaction.ins.length === 1 && transaction.outs.length === 0
    }
    case 'insufficient': {
      return transaction.ins.length === 1 && transaction.outs.length === 0
    }
    case 'repayment': {
      return transaction.ins.length === 0 && transaction.outs.length === 1
    }
    case 'replace': {
      return transaction.ins.length >= 1 && transaction.outs.length >= 1
    }
    case 'trade': {
      return transaction.ins.length >= 1 && transaction.outs.length >= 1
    }
    case 'transfer': {
      return transaction.ins.length === 0 && transaction.outs.length === 1
    }
    case 'value-down': {
      return (
        transaction.target !== undefined &&
        transaction.ins.length === 1 &&
        transaction.outs.length === 0
      )
    }
    case 'value-up': {
      return (
        transaction.target !== undefined &&
        transaction.ins.length === 0 &&
        transaction.outs.length === 1
      )
    }
    case 'withdraw': {
      return transaction.ins.length === 1 && transaction.outs.length === 0
    }
    default: {
      throw new Error(
        `Unknown transaction category: ${transaction.category satisfies never}`,
      )
    }
  }
}
